<template>
  <!--
      	作者：kmdshop
      	时间：2019-12-25
      	描述：插件中心-首页
      -->
      <div class="plus-container" v-loading="loading">
  <!-- 遍历分类数据 -->
  <div v-for="(item, index) in listData" :key="index" v-if="hasPermission(item)">
    <div class="common-form">{{ item.name }}</div>
    <div class="plus-list">
      <!-- 遍历子菜单 -->
      <div class="item" v-for="(child, num) in item.children" :key="num" v-auth="child.path">
        <div class="item-box" >
          <router-link :to="child.path">
            <span class="iconfont"><Icon :iconname="hasIcon(child.ico)"></Icon></span>
            <div class="ml10">
              <h3>{{ child.name }}</h3>
              <p>{{ child.remark }}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import PlusApi from '@/api/plus.js';
import {
  getSessionStorage
} from '@/utils/base'
var ind = 0;
export default {
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*数据*/
      listData:[],
      /*插件列表数据*/
      list: [],
      form:{
   
      }
    };
  },
  created() {
    this.getData();
  },

  methods: {

    // 获取数据
  getData() {
    let self = this;
    PlusApi.plusList({}, true)
      .then(res => {
        self.loading = false;
        self.listData = res.data.list;

        // 过滤没有权限的分类
        self.filterPermission();
      })
      .catch(error => {});
  },

  // 判断是否有权限
  hasPermission(item) {
    // 如果分类没有子项，直接返回 false
    if (!item.children || item.children.length === 0) {
      return false;
    }

    // 检查每个子项是否有权限
    for (let child of item.children) {
      let value = child.path.toLowerCase();
      let auth = getSessionStorage('authlist');
      if (auth && auth[value] === true) {
        return true; // 如果有一个子项有权限，返回 true
      }
    }
    return false; // 没有任何子项有权限，返回 false
  },

  // 过滤没有权限的分类
  filterPermission() {
    let auth = getSessionStorage('authlist');
    if (auth) {
      // 过滤 listData，去掉没有权限的分类
      this.listData = this.listData.filter(item => {
        return this.hasPermission(item);
      });
    }
  },

  // 判断是否有图标
  hasIcon(e) {
    if (e != null && e.length > 0) {
      return e;
    } else {
      return '#icon-shop-applications';
    }
  }
  }
};
</script>

<style>
  .plus-container{ min-height: 400px;}
.plus-container .common-form{ margin-bottom: 0;}
.plus-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 16px;
}
.plus-list .item {
  width: 25%;
}
.plus-list .item .item-box {
  padding: 10px;
}
.plus-list .item a {
  display: flex;
  height: 60px;
  padding-left: 10px;
  justify-content: flex-start;
  align-items: center;
}
.plus-list .item a h3 {
  font-weight: normal;
  color: #333333;
}
.plus-list .item a:hover h3 {
  color: #3a8ee6;
}
.plus-list .item a p {
  font-size: 12px;
  color: #999999;
}
.plus-list .item .item-box .iconfont {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  line-height: 40px;
  background: #3a8ee6;
}
.plus-list .item a .svg-icon {
  width: 20px;
  height: 20px;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/plus/index1.vue